module.exports = __webpack_public_path__ + "assets/img/f61893e4bdb43116d608495e75fa7b20.svg";